<template>
<div class="animated revealUp">
  <div class="white-wrapper">
    <!-- <div class="d-flex">
          <div>Name :<span class="ml-2">Karan</span></div>
    </div> -->

  <div>
    <div class="d-flex" v-if="form_data">
      <div v-for="(field,fieldKey) in form_data" :key="fieldKey">
        <div v-for="(ffield,ffieldKey) in field" :key="ffieldKey">
          <div>{{ffield.form_field_name}}: {{ffield.field_data=="true"?"YES":ffield.field_data=="undefined"?"NO":ffield.field_data}}</div>
        </div>
      </div>
    </div>
  </div>
  </div>
</div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      form_data: [],
      form_input: null,
      input_data: [],
      form_log_id: [],
      show_data: null
    };
  },
  mounted() {
    this.getFormData();
  },
  methods: {
    getFormData() {
      const { form_id, form_log_id } = this.$route.params;

      MasterService.GetInputFormData({ form_id: form_id })
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              console.log("data.Records :", data.Records);
              this.show_data = data.Records;
              for (let i in data.Records) {
                if (data.Records[i].form_log_id == form_log_id) {
                  this.form_data.push(
                    _.orderBy(data.Records[i].FormFields, "field_id")
                  );
                  this.show_data = data.Records[i];
                }
              }
              //   this.form_data = _.orderBy(data.Records, "field_id");
              console.log("this.form_data :", this.form_data);
              // console.log("this.form_log_id :", this.form_log_id);
              console.log("this.show_data :", this.show_data);
            } else {
              vue.toasted.show(data.message || "Please try later");
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/FeedbackFormComponents/singleResponse.vue